// Supabase client initialisation — replaces src/lib/firebase.js
//
// Copy .env.example to .env and fill in your Supabase project URL and anon key.
// Both values are safe to expose in client-side code; security is enforced by
// Row Level Security policies in the database, not by hiding these values.

import { createClient } from '@supabase/supabase-js';

const supabaseUrl  = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnon = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnon) {
  console.warn(
    '[B1S CRM] Supabase config missing. Copy .env.example to .env and fill in your values.'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});

// ---------------------------------------------------------------------------
// Password-recovery links. Captured at startup (before Supabase clears the URL)
// so the "choose a new password" screen opens even if the email link landed on "/".
// ---------------------------------------------------------------------------
const startHash = typeof window !== 'undefined' ? window.location.hash : '';
export const recoveryLinkError = /error_code=|error=/.test(startHash)
  ? decodeURIComponent((startHash.match(/error_description=([^&]+)/) || [])[1] || 'This link is invalid or has expired.').replace(/\+/g, ' ')
  : '';

// Invite links (sent from Supabase → Authentication → Users → Invite) sign the user in
// without a password, so send them to the same page to choose one.
const isInviteLink = /type=invite/.test(startHash);

supabase.auth.onAuthStateChange((event) => {
  if (window.location.pathname === '/reset-password') return;
  if (event === 'PASSWORD_RECOVERY') {
    window.location.replace('/reset-password');
  } else if (event === 'SIGNED_IN' && isInviteLink) {
    window.location.replace('/reset-password?mode=invite');
  }
});
